import { render, staticRenderFns } from "./CoIconImpactAnalysis.vue?vue&type=template&id=512946ae&scoped=true&"
import script from "./CoIconImpactAnalysis.vue?vue&type=script&lang=ts&"
export * from "./CoIconImpactAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./CoIconImpactAnalysis.vue?vue&type=style&index=0&id=512946ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512946ae",
  null
  
)

export default component.exports